import Document, { Html, Head, Main, NextScript } from 'next/document'

import StyledComponentsManager from 'components/misc/StyledComponentsManager'

import { themes } from 'utils/theme.utils'

import { THEME } from 'types/active'
import { ROLES } from 'types/user'

import environment from 'environment'

export const canaryCookieKey = 'newAdsEnabled'

//@ts-ignore
export default class MyDocument extends Document {
  static async getInitialProps(ctx: any) {
    let canary = 0

    if (ctx.query.canary === '0') canary = 0
    else if (ctx.query.canary === '1') canary = 1
    // else canary = Math.random() < 0.1 ? 1 : 0

    const newAdsEnabled = ctx.req.cookies[canaryCookieKey] === '1' || canary

    if (!newAdsEnabled) ctx.res.setHeader('Set-Cookie', `${canaryCookieKey}=${canary}; Path=/;`)

    const bodyClass = `${ctx.req.cookies.theme}` === THEME.DARK ? themes.dark.class : themes.light.class

    const tier = ctx.req.cookies.tbTier || 0
    const roles = ctx.req.cookies.tbR || []
    const expiresAt = new Date(ctx.req.cookies.tbFreeTrialExpiresAt || '1999-01-01')
    const now = new Date()

    const adFree =
      roles.includes(ROLES.AD_FREE) ||
      Number(tier) ||
      (environment.nodeEnv === 'development' && !environment.enableAdsOnLocalhost) ||
      now <= expiresAt

    try {
      const initialProps = await Document.getInitialProps(ctx)

      return {
        ...initialProps,
        bodyClass,
        adFree,
        newAdsEnabled,
        styles: <>{initialProps.styles}</>,
      }
    } catch (err) {
      console.error(err)

      return {
        bodyClass,
        adFree,
        newAdsEnabled,
      }
    }
  }

  render() {
    return (
      <Html lang="en">
        <Head>
          <meta property="og:site_name" content="Archidekt" />

          {/* <meta charSet="utf-8" /> */}
          {/* <meta name="theme-color" content="#000000" /> */}
          {/* <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" /> */}
          {/* <meta http-equiv="X-UA-Compatible" content="IE=edge" /> */}
          {/* <meta name="Archidekt" content="Archidekt Deck Editor" /> */}
          {/* <meta name="apple-mobile-web-app-title" content="Archidekt" /> */}
          {/* <!-- Prevent iOS from zooming on input fields WITHOUT disabling pinch to zoom --> */}
          {/* <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" /> */}
          {/* <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.3.3/semantic.min.css"
            crossOrigin="anonymous"
          /> */}
          <link
            href="https://cdn.jsdelivr.net/npm/keyrune@latest/css/keyrune.css"
            rel="stylesheet"
            type="text/css"
            crossOrigin="anonymous"
          />
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.2.6/quill.snow.css"
            crossOrigin="anonymous"
          />
          <link
            href="//cdn.jsdelivr.net/npm/mana-font@latest/css/mana.css"
            rel="stylesheet"
            type="text/css"
            crossOrigin="anonymous"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap"
            rel="stylesheet"
          />
          {/* <!-- Smooth scrolling ios - https://github.com/iamdustan/smoothscroll --> */}
          <script defer src="https://unpkg.com/smoothscroll-polyfill@0.4.4/dist/smoothscroll.min.js"></script>

          {/* Ad shit */}
          {/* @ts-ignore */}
          {!this.props.adFree && (
            <>
              {/* @ts-ignore */}
              {this.props.newAdsEnabled && <script async type="module" src="https://ads.archidekt.com/loader.js" />}

              {/* @ts-ignore */}
              {!this.props.newAdsEnabled && (
                <script
                  async
                  type="text/javascript"
                  data-noptimize="1"
                  data-cfasync="false"
                  src={`https://scripts.pubnation.com/tags/${environment.mediavineUid}.js`}
                />
              )}
            </>
          )}
        </Head>

        {/* @ts-ignore */}
        <body className={`${this.props.bodyClass} ${!this.props.adFree ? 'mediavine-ads-enabled' : ''}`}>
          <StyledComponentsManager>
            <Main />
            <NextScript />
          </StyledComponentsManager>
        </body>
      </Html>
    )
  }
}
